module.exports = "<ng-template #tooltip>\n  <span [innerHTML]=\"getToolTip(stack)\"></span>\n</ng-template>\n<img [src]=\"getImage(stack, 160)\" class=\"img-fluid\" [tooltip]=\"tooltip\" placement=\"top\" container=\"body\" containerClass=\"itemTooltip\">\n"


//////////////////
// WEBPACK FOOTER
// D:/Development/Angular/grim3212.com/src/app/containers/grim-pack/display-stack/display-stack.component.html
// module id = ../../../../../src/app/containers/grim-pack/display-stack/display-stack.component.html
// module chunks = main